import React, { useEffect, useState } from "react";
import { Bar, Chart } from "react-chartjs-2";
import moment from "moment";
import { formatMoneyWithCurrency } from "src/utils/formatter";

require("./RoundedBarsHolding.js");
const BarChartHolding = ({ labels, data, setHidden, isSale = true }) => {
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  const gradient = ctx.createLinearGradient(0, 30, 0, 200);
  gradient.addColorStop(0, "#0099ff");
  gradient.addColorStop(1, "#0099ff");

  return (
    <Bar
      height={400}
      width={600}
      data={{
        labels: labels,
        datasets: data,
        borderWidth: 1,
      }}
      options={{
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              const dataSet = tooltipItem[0].datasetIndex
              const idx = tooltipItem[0].index
              const [month, year] = data.datasets[dataSet].label[idx].split('-')
              return [`${month.toUpperCase()} ${year}`];
            },
            label: function (tooltipItem, data) {
              return formatMoneyWithCurrency(tooltipItem.value * 1000000);

            },
          },
          displayColors: false,
        },
        responsive: true,
        title: {
          display: true,
          text: `${isSale ? "Venta" : "Compras"} (1.000.000 = 1 MM)`,
          position: "right",
        },
        cornerRadius: 5,
        legend: {
          display: true,
          position: "top",
          align: "center",
          fullWidth: true,
          textDirection: "ltr",
          onClick: (_, v) => setHidden((value) => {
            if (value === v.identified) return ''
            return v.identified
          }),
          labels: {
            padding: 25,
            boxWidth: 56,
            fontSize: 14,
            generateLabels: function (a, b) {
              return [
                {
                  "text": `Período ${moment().subtract(1, 'year').year()}`,
                  "fillStyle": "#9743F2",
                  "strokeStyle": "#9743F2",
                  "hidden": data[0].hidden,
                  "identified": "past"
                },
                {
                  "text": `Período ${moment().subtract(0, 'year').year()}`,
                  "fillStyle": "#0099FF",
                  "strokeStyle": "#0099FF",
                  "hidden": data[1].hidden,
                  "identified": "present"
                },
              ]
            }
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                source: "labels",
                padding: 8,
                fontSize: 13,
                callback: (value, index, values) => {
                  return value
                }
              },
            }
          ],
          yAxes: [
            {
              position: "left",
              ticks: {
                display: true,
                labelOffset: 0,
                beginAtZero: true,
                callback(value, index) {
                  if (index % 2 == 0) return "";
                  return value > 0.9 ? `${value} MM` : `0 MM`;
                },
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
      }}
    />
  );
};

export default BarChartHolding;
